export const SET_AVATAR = 'SET_AVATAR';
export const SAVE_AVATAR = 'SAVE_AVATAR';
export const SAVED_AVATAR = 'SAVED_AVATAR';
export const OPEN_AVATAR_UPLOAD = 'OPEN_AVATAR_UPLOAD';
export const CLOSE_AVATAR_UPLOAD = 'CLOSE_AVATAR_UPLOAD';